import React, { useEffect, useState } from "react";
import BackButton from "../bars/BackButton";
import { useLocation, useNavigate } from "react-router-dom";
import PromotionCard from "./PromotionCard";
import RedirectCommonModal from "../../components/alert/RedirectCommonModal";

function PromotionList() {
  const location = useLocation();
  const navigate = useNavigate();
  const promotionList = location?.state?.promotionList;
  const menuVisibility=location?.state?.menuVisibility;
  const [alert, setAlert] =  useState("")
  console.log(location?.state)

  const alertMsg = (msg)=>{
    setAlert(msg)
  }

  useEffect(()=>{
    if(!location?.state){
      console.log("object")
      navigate("../home")
    }
  },[location])
  
  return (
    <div className="section-wrap mt-5 promotion-section">
      <div className="flex items-center gap-3">
        <BackButton />
        <div>Offers</div>
      </div>
      <div className="flex flex-col gap-4 my-6">
        {promotionList?.map((item, i) => {
          return <PromotionCard key={i} page data={item} menuVisibility={menuVisibility} alertMsg={(msg)=>{alertMsg(msg)}}/>;
        })}
      </div>
      {alert && <RedirectCommonModal para={alert} hide={()=>setAlert("")}/>}
    </div>
  );
}

export default PromotionList;
